import {
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  RequestModels_Usages_Reading_SaveRequestModel,
  ResponseModels_Usages_Reading_ResponseModel,
  ResponseModels_Usages_Reading_SaveReadingResultResponseModel,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type SaveReadingByReadingId = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  requestBody?: RequestModels_Usages_Reading_SaveRequestModel;
};
/**
 * Save a reading for an account of a customer via public flow
 *
 * @returns ResponseModels_Usages_Reading_SaveReadingResultResponseModel Success
 */
export function saveReadingByReadingId(
  { businessUnit, label, requestBody }: SaveReadingByReadingId,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Reading_SaveReadingResultResponseModel> {
  return request(
    {
      method: 'PUT',
      path: `/dxpweb/public/${businessUnit}/${label}/reading`,
      body: requestBody,
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}

type GetReadingByReadingId = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  readingId: number;
  houseNumber: number;
};
/**
 * Gets the empty reading for an account of a customer.
 *
 * @returns ResponseModels_Usages_Reading_ResponseModel Success
 */
export function getReadingByReadingId(
  { businessUnit, label, readingId, houseNumber }: GetReadingByReadingId,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseModels_Usages_Reading_ResponseModel> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/reading/${readingId}`,
      query: { houseNumber },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
